// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!../index.html');
  require('raw-loader!../_main.html');
}
// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';
import '../lib/swiper';
import '../scss/swiper.scss';
import $ from 'jquery';
import * as service from './service';
service.init();

window.addEventListener('load', () => {
  const shopSwiper = new Swiper('.part4 .swiper-container', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 6,// 轮播图数量
    autoplay: true,
    navigation: {
      nextEl: '.part4 .swiper-button-next',
      prevEl: '.part4 .swiper-button-prev',
    },
    on: {
      progress: function () {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          let slideProgress = this.slides[i].progress;
          let modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          let translate = ((slideProgress * modify * 442) / 1080) * 100 + 'vh';
          let scale = 1 - Math.abs(slideProgress) / 5;
          let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          if (Math.abs(slideProgress) > 3) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function (transition) {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          slide.transition(transition);
        }
      },
      resize() {
        let width = $('.part4 .swiper-container').width();
        $('.part4 .swiper-container img').css('width', `${width}px`);
      },
    },
  });
});